export default function DeRiskingSectionFr() {
  const pillars = [
    {
      icon: 'ri-error-warning-line',
      title: 'Récupération après perte de source unique',
      desc: 'Lorsqu&apos;un fournisseur critique disparaît du jour au lendemain, nous agissons rapidement pour identifier, qualifier et valider des sources de remplacement — minimisant les perturbations de vos opérations.',
    },
    {
      icon: 'ri-links-line',
      title: 'Atténuation de la dépendance à source unique',
      desc: 'Nous cartographions les vulnérabilités de votre chaîne d&apos;approvisionnement et construisons des stratégies multi-sources redondantes qui éliminent les points de défaillance uniques avant qu&apos;ils ne deviennent des crises.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Optimisation du coût par kilogramme',
      desc: 'Des prix exorbitants sont souvent le symptôme d&apos;une visibilité limitée du marché. Nous analysons, négocions et restructurons vos dépenses en ingrédients pour offrir des économies mesurables.',
    },
    {
      icon: 'ri-lock-password-line',
      title: 'Accès propriétaire et exclusivité',
      desc: 'Nous vous aidons à sécuriser des ingrédients personnalisés exclusifs que vos concurrents ne peuvent tout simplement pas accéder — transformant la stratégie de chaîne d&apos;approvisionnement en un avantage concurrentiel durable.',
    },
  ];

  return (
    <section className="w-full bg-white py-24 px-6 md:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-start mb-16">
          <div className="lg:w-2/5">
            <span className="text-emerald-600 text-xs font-bold uppercase tracking-widest">
              Services stratégiques
            </span>
            <h2
              className="text-4xl md:text-5xl font-extrabold text-stone-800 mt-4 leading-tight"
              style={{ fontFamily: "'DM Serif Display', serif" }}
            >
              Dérisquage stratégique &amp;
              <br />
              <span className="text-emerald-600">Développement sur mesure</span>
            </h2>
            <div className="w-16 h-1 bg-emerald-600 mt-6 rounded-full" />
          </div>

          <div className="lg:w-3/5 flex flex-col justify-center">
            <p className="text-gray-600 text-base leading-relaxed mb-5">
              Nous fournissons des <strong className="text-stone-800">Services de Dérisquage Stratégique et de Développement sur Mesure</strong> pour les ingrédients à haute valeur et mission critique. Que vous naviguiez la perte soudaine d&apos;un fournisseur unique, atténuiez la vulnérabilité d&apos;une dépendance à source unique, ou cherchiez à optimiser des prix exorbitants par kilogramme, nous travaillons à fournir des solutions viables et validées.
            </p>
            <p className="text-gray-600 text-base leading-relaxed">
              En vous démarquant des ingrédients banalisés utilisés par vos concurrents, nous vous aidons à sécuriser un <strong className="text-stone-800">Accès Propriétaire</strong> et des ingrédients personnalisés exclusifs — transformant la fragilité de la chaîne d&apos;approvisionnement en un avantage concurrentiel distinct et durable.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-16">
          {pillars.map((p) => (
            <div
              key={p.title}
              className="bg-stone-50 border border-stone-100 rounded-lg p-6 hover:-translate-y-1 transition-transform duration-200"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-emerald-700 mb-5">
                <i className={`${p.icon} text-white text-xl`} />
              </div>
              <h3 className="text-stone-800 font-bold text-sm mb-2 leading-snug">{p.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed" dangerouslySetInnerHTML={{ __html: p.desc }} />
            </div>
          ))}
        </div>

        <div className="relative rounded-lg overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/f234f48aed1e51692de7be95e5b5ae22.jpg"
            alt="Dérisquage stratégique"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-stone-900/80 via-stone-900/60 to-emerald-900/70" />
          <div className="relative z-10 px-10 py-12 flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="max-w-2xl">
              <p
                className="text-white text-2xl md:text-3xl font-extrabold leading-snug mb-3"
                style={{ fontFamily: "'DM Serif Display', serif" }}
              >
                Transformez la fragilité de la chaîne d&apos;approvisionnement en avantage concurrentiel
              </p>
              <p className="text-stone-300 text-sm leading-relaxed">
                Les ingrédients mission-critiques exigent un approvisionnement mission-critique. Laissez-nous construire la chaîne d&apos;approvisionnement résiliente et protégée que votre entreprise mérite.
              </p>
            </div>
            <a
              href="mailto:info@max-sourcing.com"
              className="shrink-0 bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-sm px-8 py-4 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Démarrer une conversation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
